import {useEffect, useRef, useState} from 'react';
import {UseDelete, UseGet, UseHttpMessages, UsePost} from "../../hooks/http";
import {UseLimit, UseOrder} from "../../hooks/settings";
import {UseMessage} from "../../hooks/UseMessage";

import ListingTable from "../../components/listing/listing";
import Button from "../../components/button";
import {Modal} from "react-bootstrap";
import Text from "../../components/input/text";
import Select from "../../components/input/select";
import UseGetFormData from "../../hooks/UseGetFormData";
import InputDate from "../../components/input/date";


const Consents = ({audience, id_entity}) => {
    const searchColumn = 'name'
    const formRef = useRef()
    const [isLoading, setIsLoading] = useState(true)
    const [entities, setEntities] = useState([])
    const [totalEntities, setTotalEntities] = useState(0)
    const [currentOffset, setCurrentOffset] = useState(0)
    const [currentLimit, setCurrentLimit] = useState(UseLimit)
    const [currentOrder, setCurrentOrder] = useState(UseOrder)
    const [searchValue, setSearchValue] = useState("")
    const [bulkAction, setBulkAction] = useState()

    const [errors, setErrors] = useState()
    const [lastUpdated, setLastUpdated] = useState(Date.now())
    const [showModal, setShowModal] = useState(false);
    const [consentTypes, setConsentTypes] = useState([])


    const fetchData = async () => {
        let filters = {
            limit      : currentLimit,
            offset     : currentOffset,
            sortBy     : "created_at",
            sortOrder  : currentOrder,
            id_audience: audience?._id?.$oid,
            id_entity  : id_entity
        };

        if (searchValue.trim() !== "") {
            filters["findBy"] = searchColumn;
            filters["findTerm"] = searchValue;
        }

        return await UseGet(`/audiences/${audience?._id?.$oid}/entities/${id_entity}/consents/get`, {});
    };


    useEffect(() => {
        fetchData().then((response) => {
            const consent_types = []
            if (audience?.consent_types?.length > 0) {
                audience.consent_types.map(consent => {
                    consent_types.push({value: consent.slug, label: consent.name})
                })
            }

            setEntities(response);
            setConsentTypes(consent_types)
            setTotalEntities(response?.length)
            setIsLoading(false);
        });
    }, [currentOffset, currentLimit, searchValue, currentOrder, lastUpdated]);


    const handleDelete = async (selected) => {
        if (selected.length === 0) {
            UseMessage("error", "Please choose some items")
        } else {

            await UseDelete(`/audiences/${audience?._id?.$oid}/entities/${id_entity}/consents/delete`,
                {
                    data: {idx: selected}, onSuccess: (response) => {
                        setLastUpdated(Date.now())
                    }
                }
            );
        }
    };


    const addNewEntity = () => {
        setShowModal(true)
    }

    const handleModalClose = () => {
        setShowModal(false)
        setErrors(undefined)
    }

    const handleSubmit = async (ev) => {
        ev.preventDefault()
        setIsLoading(true)
        const FormData = UseGetFormData(formRef)
        const Request = await UsePost(
            `/audiences/${audience?._id?.$oid}/entities/${id_entity}/consents/insert`,
            {
                data: [
                    {
                        scope      : FormData.get('scope'),
                        origin     : FormData.get('origin'),
                        device     : FormData.get('device'),
                        fingerprint: FormData.get('fingerprint'),
                        started_at : FormData.get('started_at').replace('T', ' '),
                        finished_at : FormData.get('finished_at').replace('T', ' '),
                    }
                ]
            }
        )

        UseHttpMessages(Request, ev => {
            setShowModal(false)
            setLastUpdated(Date.now())
        }, ev => {
            setErrors(ev)
            setIsLoading(false)
        });

    }


    const ListingOptions = {
        entities      : entities,
        isLoading     : isLoading,
        currentPage   : Math.ceil(currentOffset / currentLimit) + 1,
        totalEntities : totalEntities,
        currentLimit  : currentLimit,
        currentOrder  : currentOrder,
        searchColumn  : searchColumn,
        template      : "table",
        onSearch      : (value) => {
            setCurrentOffset(0);
            setSearchValue(value);
        },
        onCleanSearch : () => {
            setSearchValue("");
        },
        onChangePage  : (page) => {
            setCurrentOffset(currentLimit * (page - 1));
        },
        onChangeLimit : (ev) => {
            UseLimit(setCurrentLimit, ev.target.text);
        },
        onChangeOrder : (ev) => {
            UseOrder(setCurrentOrder, ev.target.text);
        },
        onChangeAction: (action) => {
            setBulkAction(action);
        },
        onClickApply  : (selected) => {
            if (typeof bulkAction == "undefined") {
                UseMessage("error", "Please choose an action")
            } else {
                bulkAction["action"](selected);
            }
        },
        columns       : [
            {
                label: "Id", prop: "id", size: 25, output: (entity) => {
                    return <strong>{entity?._id?.$oid.substr(-5)}</strong>;
                }
            },
            {label: "Scope", prop: "scope", size: 25},
            {label: "Device", prop: "device", size: 25},
            {label: "Origin", prop: "origin", size: 25},
            {label: "Fingerprint", prop: "fingerprint"},
            {label: "Started at", size: 15, prop: "started_at"},
            {label: "Finished at", size: 15, prop: "finished_at"}
        ],
        filters       : [],
        actions       : [
            {value: "delete", label: "Delete", action: (selected) => handleDelete(selected)}
        ],
        edit          : {
            path : `/audiences/:id`,
            label: "Edit audience",
            icon : "edit"
        },
        card          : false,
        addons        : {
            top: {
                left:
                    <div className="d-flex">
                        <div className="me-2">
                            <Button
                                size="sm"
                                icon="plus"
                                color="primary"
                                isReady={!isLoading}
                                onClick={addNewEntity}
                                style={{height: '32px'}}
                            />
                        </div>
                    </div>
            }
        }
    };


    return (
        <>
            <ListingTable {...ListingOptions} />
            <Modal size="md" className="add-sidebar-padding" centered show={showModal} onHide={handleModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title as="h6">Add Consents</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form ref={formRef} onSubmit={handleSubmit} autoComplete="off" style={{padding: '0px 15px 0px 15px'}}>

                        <Select
                            size="md"
                            name="scope"
                            required={true}
                            label={"Scope"}
                            isReady={!isLoading}
                            error={errors?.scope}
                            options={consentTypes}
                            placeholder="Choose consent scope"
                        />

                        <Text
                            size="md"
                            required={true}
                            isReady={!isLoading}
                            name="origin"
                            label={"Origin"}
                            error={errors?.origin}
                            placeholder="Lead origin input: website url or call-in number"
                        />

                        <Text
                            size="md"
                            name="device"
                            required={true}
                            label={"Device"}
                            isReady={!isLoading}
                            error={errors?.device}
                            placeholder="Consent device can be a phone or an email address"
                        />


                        <Text
                            size="md"
                            name="fingerprint"
                            required={true}
                            label={"Fingerprint"}
                            isReady={!isLoading}
                            error={errors?.fingerprint}
                            placeholder="Lead ip or name of the recording"
                        />


                        <InputDate
                            size="md"
                            required={true}
                            name="started_at"
                            label={"Started at"}
                            isReady={!isLoading}
                            error={errors?.started_at}
                        />

                        <InputDate
                            size="md"
                            required={true}
                            name="finished_at"
                            label={"Finish at"}
                            isReady={!isLoading}
                            error={errors?.finished_at}
                        />

                        <Button
                            size="sm"
                            icon="check"
                            color="primary"
                            label="Create"
                            style={{marginTop: '20px'}}
                            isReady={!isLoading}
                        />
                    </form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default Consents;